/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Nonexistent_DocumentsInputs */

const en_task_field_nonexistent_documents = /** @type {(inputs: Task_Field_Nonexistent_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nonexistent documents`)
};

const pt_br2_task_field_nonexistent_documents = /** @type {(inputs: Task_Field_Nonexistent_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos inexistentes`)
};

/**
* | output |
* | --- |
* | "Nonexistent documents" |
*
* @param {Task_Field_Nonexistent_DocumentsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_nonexistent_documents = /** @type {((inputs?: Task_Field_Nonexistent_DocumentsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Nonexistent_DocumentsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_nonexistent_documents(inputs)
	return pt_br2_task_field_nonexistent_documents(inputs)
});